/**
 * The cache key for the shared audit trail.
 *
 * Its own file rather than sitting beside `AuditLogPanel`, so that a module's
 * mutations can invalidate the trail without importing a component — and so the
 * panel file exports only a component, which is what keeps fast refresh working.
 *
 * The key lives with the panel's concern rather than in each module's own key
 * factory because the panel owns the query: a module inventing its own key
 * would invalidate something nothing reads, and the trail would silently stop
 * refreshing after a write.
 */
export const auditLogKeys = {
  all: ['audit-logs'] as const,
  forSubject: (subjectType: string, subjectId: string) =>
    [...auditLogKeys.all, subjectType, subjectId] as const,
};
